// src/Pages/ReturnRefundsandCancellation.js
import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../Pages/Navbar/JobSeekerNavbar";
import Footer from "../../Footer/Footer";
import { Container } from "react-bootstrap";
import "./ReturnPolicy.css";

function ReturnRefundsandCancellation() {
  const navigate = useNavigate();

  const handleGmailCompose = (e) => {
    e.preventDefault();
    const email = "support@gulfworker.net"; // ✅ updated support email
    const subject = encodeURIComponent("Support Request: Returns & Refunds");
    const body = encodeURIComponent(
      "Hi Gulfworker Team,\n\nI have a question regarding the Returns, Refunds & Cancellation Policy..."
    );

    // ✅ Open Gmail compose in new tab
    const gmailComposeURL = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}&body=${body}`;
    window.open(gmailComposeURL, "_blank");

    // ✅ Navigate back after 2 seconds
    setTimeout(() => {
      navigate("/jobseeker-returns-refunds-cancellation");
    }, 2000);
  };

  return (
    <>
      <Navbar />
      <div className="policy-section py-5 mt-5">
        <Container style={{textAlign:'justify'}}>
          <h1 className="mb-4 text-center fw-bold">
            Returns, Refunds & Cancellation Policy
          </h1>

          <p>
            This Returns, Refunds & Cancellation Policy governs the subscription
            and payment services provided on <strong>Gulfworker.net</strong>.
            Please read carefully before making any purchase.
          </p>

          <div className="mt-4">
            <h4>1. Subscription Services</h4>
            <p>
              Employers may purchase premium subscriptions to highlight or
              feature job postings. Subscriptions are activated immediately upon
              successful payment.
            </p>

            <h4>2. No Returns</h4>
            <p>
              As services are delivered digitally, once a subscription is
              activated, it cannot be returned.
            </p>

            <h4>3. Refund Policy</h4>
            <ul>
              <li>
                Fees paid for subscription services are <strong>non-refundable</strong>.
              </li>
              <li>
                Refunds will only be provided where required by applicable law or
                in cases of duplicate payments.
              </li>
              <li>
                Any refund request must be submitted to{" "}
                <a href="#" onClick={handleGmailCompose}>
                  support@gulfworker.net
                </a>{" "}
                within 7 working days of payment.
              </li>
            </ul>

            <h4>4. Cancellation Policy</h4>
            <ul>
              <li>
                Employers may cancel their subscription at any time from their
                account settings.
              </li>
              <li>
                Cancellation stops auto-renewal for the next billing cycle but
                does not entitle the employer to a refund for the current cycle.
              </li>
            </ul>

            <h4>5. Dispute Resolution</h4>
            <p>
              In case of disputes regarding payments, please contact our support
              team. Gulfworker.net will review the matter in accordance with our
              Terms & Conditions.
            </p>

            <h4>6. Policy Updates</h4>
            <p>
              Gulfworker.net reserves the right to update this policy at any
              time. Updates will be effective once published on our website.
            </p>
          </div>
        </Container>
      </div>
      <Footer />
    </>
  );
}

export default ReturnRefundsandCancellation;
